export function display_errors($errors, response, $form = null) {
    let has_error = false;
    $errors.textContent = '';

    for (const field in response.errors) {
        const $error = document.createElement('p');
        $error.textContent = response.errors[field];

        if ($form) {
            const $field = $form[field];
            if ($field) $field.classList.add('error');
        }

        $errors.appendChild($error);
        has_error = true;
    }

    if (has_error) $errors.classList.remove('hidden');
}
